import { requestOptions } from '../helpers/request-options'
import { handleResponse } from '../helpers/handle-response'

export const contactsService = {
  getData,
  add,
  update,
  getDataById,
  deleteDataById,
  addOrgToContact,
  updateOrgToContact,
  uploadFile,
  getFileFile,
  deleteFile,
  fetchLinkedIn,
  getFileFileByContentAndObject
}

function getData ({ q = '', limit = '999999999', ordering = '', offset = 0 }) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/contacts/?${q}&limit=${limit}&ordering=${ordering}&offset=${offset}&expand=organizations_contacts,organizations_contacts.organization&organizations_addresses__property_status=active`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(contacts => {
      return contacts
    })
}

function getDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/contacts/${id}/?expand=organizations_contacts,organizations_contacts.organization,created_by,modified_by`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(contacts => {
      return contacts
    })
}

function deleteDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/contacts/${id}/`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(contacts => {
      return contacts
    })
}

function add (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/contacts/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(contacts => {
      return contacts
    })
}

function update (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/contacts/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(contacts => {
      return contacts
    })
}

function addOrgToContact (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organization-contacts/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(addresses => {
      return addresses
    })
}

function updateOrgToContact (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organization-contacts/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(addresses => {
      return addresses
    })
}

function uploadFile (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/`
  return fetch(url, requestOptions.postFormData(payload))
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function getFileFile (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/?limit=9999999&object_id=${id}`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function getFileFileByContentAndObject (content, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/?limit=9999999&content_type=${content}&object_id=${id}`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function deleteFile (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/${id}`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function fetchLinkedIn (slug, id) {
  const url = `https://discfetcher.azurewebsites.net/fetch/${slug}/${id}`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data
    })
}



// WEBPACK FOOTER //
// ./src/services/contacts.service.js